module.exports = __webpack_public_path__ + "img/airtkeBig.78253b53.jpg";